// extracted by mini-css-extract-plugin
export default {"dropzone":"styles_dropzone__fpW8W","active":"styles_active__R2VR6","container":"styles_container__KaXm-"};